// extracted by mini-css-extract-plugin
export default {"map":"headquarters_map__1OkkJ","title":"headquarters_title__z3Zcb"};